class DynamicCardLayout {
  constructor() {
    this.init();
  }

  init() {
    // DOM이 로드된 후 실행
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.adjustCardHeights());
    } else {
      this.adjustCardHeights();
    }

    // 윈도우 리사이즈 시에도 실행
    window.addEventListener(
      'resize',
      this.debounce(() => this.adjustCardHeights(), 250)
    );
  }

  adjustCardHeights() {
    // PC에서만 실행 (990px 이상)
    if (window.innerWidth < 990) {
      this.resetCardPadding();
      return;
    }

    const productCards = document.querySelectorAll('.product-card-wrapper');
    if (productCards.length === 0) return;

    // 카드들을 행별로 그룹화
    const cardsByRow = this.groupCardsByRow(productCards);

    // 각 행별로 높이 조정
    cardsByRow.forEach((rowCards) => {
      this.adjustRowHeight(rowCards);
    });
  }

  groupCardsByRow(cards) {
    const cardsByRow = [];
    let currentRow = [];
    let currentTop = null;

    Array.from(cards).forEach((card) => {
      const rect = card.getBoundingClientRect();
      const cardTop = Math.round(rect.top);

      if (currentTop === null || Math.abs(cardTop - currentTop) < 10) {
        // 같은 행에 있는 카드
        currentRow.push(card);
        currentTop = cardTop;
      } else {
        // 새로운 행 시작
        if (currentRow.length > 0) {
          cardsByRow.push([...currentRow]);
        }
        currentRow = [card];
        currentTop = cardTop;
      }
    });

    // 마지막 행 추가
    if (currentRow.length > 0) {
      cardsByRow.push(currentRow);
    }

    return cardsByRow;
  }

  adjustRowHeight(rowCards) {
    let maxHeight = 0;

    // 각 카드의 .card__information 높이 측정
    rowCards.forEach((cardWrapper) => {
      const cardInfo = cardWrapper.querySelector('.card__information');
      if (cardInfo) {
        const height = cardInfo.offsetHeight;
        maxHeight = Math.max(maxHeight, height);
      }
    });

    // 최대 높이 + 70px를 padding-bottom으로 설정
    const paddingBottom = maxHeight + 20;
    rowCards.forEach((cardWrapper) => {
      cardWrapper.style.paddingBottom = `${paddingBottom}px`;
    });

    console.log(`Row adjusted: max height ${maxHeight}px, padding-bottom set to ${paddingBottom}px`);
  }

  resetCardPadding() {
    // 모바일에서는 기본 패딩으로 리셋
    const productCards = document.querySelectorAll('.product-card-wrapper');
    productCards.forEach((card) => {
      card.style.paddingBottom = '';
    });
  }

  // 디바운스 함수 - 리사이즈 이벤트 최적화
  debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  }
}

// 페이지 로드 시 초기화
new DynamicCardLayout();
